import { render } from "./Customer.vue?vue&type=template&id=8cd22750&scoped=true"
import script from "./Customer.vue?vue&type=script&lang=ts"
export * from "./Customer.vue?vue&type=script&lang=ts"

import "./Customer.vue?vue&type=style&index=0&id=8cd22750&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-8cd22750"

export default script